import { useState, useCallback } from 'react';
import { servicesAPI, adminAPI } from '@/services/api';
import { MSAService } from '@/types';
import { HealthStatus } from '@/types/health';

export const useCustomerUserServices = () => {
  const [subscribedServices, setSubscribedServices] = useState<MSAService[]>([]);
  const [servicesLoading, setServicesLoading] = useState(true);
  const [healthStatuses, setHealthStatuses] = useState<Record<number, HealthStatus>>({});
  const [subscribedServiceIds, setSubscribedServiceIds] = useState<Set<number>>(new Set());

  const fetchSubscribedServices = useCallback(async () => {
    try {
      setServicesLoading(true);
      const userServices = await servicesAPI.getUserServices();
      setSubscribedServices(userServices || []);
      
      const subscribedIds = new Set<number>((userServices || []).map((s: MSAService) => s.id));
      setSubscribedServiceIds(subscribedIds);
      
      if (userServices && userServices.length > 0) {
        const serviceSlugs = userServices.map((s: MSAService) => s.service_slug);
        try {
          const healthResponse = await adminAPI.batchHealthCheck(serviceSlugs);
          const statusMap: Record<number, HealthStatus> = {};
          // service_slug를 service_id로 매핑
          Object.keys(healthResponse.results).forEach((slug) => {
            const service = userServices.find((s: MSAService) => s.service_slug === slug);
            if (service) {
              statusMap[service.id] = healthResponse.results[slug].status;
            }
          });
          setHealthStatuses(statusMap);
        } catch (healthError) {
          console.error('Health check failed:', healthError);
        }
      }
    } catch (error: unknown) {
      console.error('Failed to fetch services:', error);
    } finally {
      setServicesLoading(false);
    }
  }, []);

  return {
    subscribedServices,
    servicesLoading,
    healthStatuses,
    subscribedServiceIds,
    setSubscribedServiceIds,
    setHealthStatuses,
    fetchSubscribedServices,
  };
};

